import { render, staticRenderFns } from "./AddNumberSet.vue?vue&type=template&id=80871728&scoped=true"
import script from "./AddNumberSet.vue?vue&type=script&lang=js"
export * from "./AddNumberSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80871728",
  null
  
)

export default component.exports